var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9023 4.17573C11.6801 3.94142 11.3199 3.94142 11.0977 4.17573L7.30458 8.17573C7.08238 8.41005 7.08238 8.78995 7.30458 9.02426C7.52677 9.25857 7.88702 9.25857 8.10922 9.02426L10.931 6.04853V17C10.931 17.3314 11.1858 17.6 11.5 17.6C11.8142 17.6 12.069 17.3314 12.069 17V6.04853L14.8908 9.02426C15.113 9.25857 15.4732 9.25857 15.6954 9.02426C15.9176 8.78995 15.9176 8.41005 15.6954 8.17573L11.9023 4.17573ZM6.56897 18.8C6.25474 18.8 6 19.0686 6 19.4C6 19.7314 6.25474 20 6.56897 20H16.431C16.7453 20 17 19.7314 17 19.4C17 19.0686 16.7453 18.8 16.431 18.8H6.56897Z",
    fill: "#96C11F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/ExportIcon.938bf5bdd5b3be6fc0d2e7ce7c8e9a88.svg";
export { ForwardRef as ReactComponent };